(function () {
  /* Movement past this before we treat the gesture as drag + pointer capture */
  var DRAG_THRESHOLD_PX = 8;

  function initTabNavDragScroll(tabNav, section) {
    var isPointerDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var didDrag = false;
    var dragging = false;
    var activePointerId = null;

    function onPointerMove(e) {
      if (!isPointerDown || e.pointerId !== activePointerId) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) <= DRAG_THRESHOLD_PX) return;
        dragging = true;
        didDrag = true;
        try {
          tabNav.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      tabNav.scrollLeft = startScrollLeft - dx;
    }

    function onPointerEnd(e) {
      if (!isPointerDown || e.pointerId !== activePointerId) return;
      window.removeEventListener('pointermove', onPointerMove, true);
      window.removeEventListener('pointerup', onPointerEnd, true);
      window.removeEventListener('pointercancel', onPointerEnd, true);
      try {
        if (tabNav.hasPointerCapture(e.pointerId)) {
          tabNav.releasePointerCapture(e.pointerId);
        }
      } catch (err) {}
      isPointerDown = false;
      activePointerId = null;
      tabNav.style.userSelect = '';
      if (window.matchMedia('(min-width: 990px)').matches) {
        tabNav.style.cursor = '';
      }
      dragging = false;
    }

    tabNav.addEventListener('pointerdown', function (e) {
      /* Touch keeps native overflow scrolling; mouse gets click-drag */
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      isPointerDown = true;
      didDrag = false;
      dragging = false;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = tabNav.scrollLeft;
      tabNav.style.userSelect = 'none';
      if (window.matchMedia('(min-width: 990px)').matches) {
        tabNav.style.cursor = 'grabbing';
      }
      window.addEventListener('pointermove', onPointerMove, true);
      window.addEventListener('pointerup', onPointerEnd, true);
      window.addEventListener('pointercancel', onPointerEnd, true);
    });

    section.addEventListener(
      'click',
      function (e) {
        if (!didDrag) return;
        var target = e.target.closest('button[role="tab"][data-tab]');
        if (!target || !section.contains(target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        didDrag = false;
      },
      true
    );
  }

  /* Horizontal scroll of nav only, never the page, using the nav as the scroll container */
  function scrollTabIntoView(tabNav, tab) {
    if (!tabNav || !tab) return;
    var navRect = tabNav.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();
    var padding = 16;
    var delta = 0;
    if (tabRect.left < navRect.left + padding) {
      delta = tabRect.left - navRect.left - padding;
    } else if (tabRect.right > navRect.right - padding) {
      delta = tabRect.right - navRect.right + padding;
    }
    if (delta !== 0) {
      tabNav.scrollBy({ left: delta, behavior: 'smooth' });
    }
  }

  function initSection(section) {
    if (!section) return;

    var tabNav = section.querySelector('nav[role="tablist"]');
    if (tabNav) {
      initTabNavDragScroll(tabNav, section);
    }

    var tabs = Array.prototype.slice.call(
      section.querySelectorAll('button[role="tab"][data-tab]')
    );
    var panels = section.querySelectorAll('[data-tab-panel]');
    var buttons = section.querySelectorAll('[data-tab-button]');
    var prevArrow = section.querySelector('[data-tab-arrow="prev"]');
    var nextArrow = section.querySelector('[data-tab-arrow="next"]');

    function getActiveIndex() {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    function updateArrowState() {
      if (!prevArrow || !nextArrow) return;
      var idx = getActiveIndex();
      prevArrow.disabled = idx <= 0;
      nextArrow.disabled = idx >= tabs.length - 1;
    }

    function activateTab(activeTab, options) {
      var tabId = activeTab.dataset.tab;

      /* Update tab aria states (Tailwind aria-selected:* handles visuals) */
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', t === activeTab ? 'true' : 'false');
      });

      /* Toggle panel visibility */
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.tabPanel !== tabId;
      });

      /* Toggle button visibility */
      buttons.forEach(function (btn) {
        btn.hidden = btn.dataset.tabButton !== tabId;
      });

      updateArrowState();

      if (options && options.scrollIntoView) {
        scrollTabIntoView(tabNav, activeTab);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        var idx = getActiveIndex();
        if (idx > 0) activateTab(tabs[idx - 1], { scrollIntoView: true });
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        var idx = getActiveIndex();
        if (idx < tabs.length - 1) activateTab(tabs[idx + 1], { scrollIntoView: true });
      });
    }

    updateArrowState();
  }

  /* Initialize all section instances on the page */
  document.querySelectorAll('[data-oddit-tab-grid]').forEach(initSection);

  /* Theme editor support: re-initialize when a section is added or reloaded */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initSection(event.target.querySelector('[data-oddit-tab-grid]'));
    });
  }
})();
